<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_79_122)">
      <path
        d="M13.9957 8.00163L4.66235 8.00163"
        stroke="#2D323C"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M10.665 12.0017L14.665 8.00168L10.665 4.00168"
        stroke="#2D323C"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M9.33423 2.00169L3.18026 2.00168C2.71894 1.97558 2.26597 2.13291 1.92017 2.43937C1.57437 2.74583 1.36375 3.17657 1.33423 3.63768L1.33423 12.365C1.36375 12.8261 1.57437 13.2569 1.92017 13.5633C2.26597 13.8698 2.71894 14.0271 3.18026 14.001L9.33423 14.001"
        stroke="#2D323C"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_122">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Exit',
}
</script>

<style lang="scss" scoped></style>
